import React, { useState } from "react";
import MapAdmin from "./MapAdmin";
import OptionsAdmin from "./OptionsAdmin";
import MyAccount from "./MyAccount";   
import OrderListAdmin from "./OrderListAdmin";
import DeliveryListAdmin from "./DeliveryListAdmin";
import SearchGlobal from "./SearchGlobal";
import ResumenAdmin from "./ResumenAdmin";
import Mensajeria from "./Mensajeria";
import Location from "./Location";
import Inventory from "./Inventory";
import AdminPanel from "./AdminPanel";
import SellersAnalytics from "./SellersAnalytics";
import ControlTower from "./ControlTower";
import AdminPrintDeliveries from "./AdminPrintDeliveries";
import AdminStatistics from "./AdminStatistics";

function MainAdmin({ user_id, username, onLogout, email, phone_number, onUpdateUser }) {
    const [activeComponent, setActiveComponent] = useState('OptionsAdmin');
    
    
    

    const handleBackClick = () => {
        setActiveComponent('MapAdmin');
         
    };
    
    const handleMenuClick = () => {
        setActiveComponent('OptionsAdmin');
    };

    const handleOptionClick = (option) => {
        if (option === 'back') {
            setActiveComponent(activeComponent === 'MapAdmin' ? 'admin' : 'MapAdmin');
        } else if (option === 'MapSelectionAdmin') {
            setActiveComponent('MapSelectionAdmin');
        } else if (option === 'OrderListAdmin') {
            setActiveComponent('OrderListAdmin')
        } else if (option === 'DeliveryListAdmin') {
            setActiveComponent('DeliveryListAdmin')
        } else if (option === 'OptionsAdmin') {
            setActiveComponent('OptionsAdmin')
        } else if (option === 'admin') {
            setActiveComponent('admin')
        } else if (option === 'SearchGlobal') {
            setActiveComponent('SearchGlobal')
        } else if (option === 'ResumenAdmin') {
            setActiveComponent('ResumenAdmin')
        }

        
        
        else {
            setActiveComponent('MyAccountAdmin')
            // Handle other options
            
        }
    };

    return (
        <div className="container-fluid p-0">
            {activeComponent === 'MapAdmin' && 
            <div className="map-container">
                
                    <MapAdmin setActiveComponent={setActiveComponent} handleMenuClick={handleMenuClick} onOptionClick={handleOptionClick} userId={user_id}/>
                     
            </div>
            }
            {activeComponent === 'OptionsAdmin' && 
                <OptionsAdmin username={username} onOptionClick={handleOptionClick} onBackClick={handleBackClick} onLogout={onLogout} setActiveComponent={setActiveComponent}/>
            }
            {activeComponent === 'AccountAdmin' && <MyAccount onUpdateUser={onUpdateUser} userId={user_id} username={username} phoneNumber={phone_number} email={email} onLogout={onLogout} setActiveComponent={setActiveComponent} />}
            {activeComponent === 'OrderListAdmin' &&
                <OrderListAdmin onOptionClick={handleOptionClick} onBackClick={handleBackClick} userId={user_id}/>
            }
            {activeComponent === 'DeliveryListAdmin' &&
                <DeliveryListAdmin activeComponent={activeComponent} onOptionClick={handleOptionClick} onBackClick={handleBackClick} userId={user_id}/>
            }
            {activeComponent === 'Inventory' && <Inventory userId={user_id} setActiveComponent={setActiveComponent}/>}
            {activeComponent === 'Chat' && <AdminPanel setActiveComponent={setActiveComponent} userId={user_id} />}
            {activeComponent === 'SearchGlobal' &&

                <SearchGlobal onBackClick={handleBackClick} userId={user_id}/>
            }
            {activeComponent === 'ResumenAdmin' &&
                <ResumenAdmin onBackClick={handleBackClick} userId={user_id}/>    

            }
            {activeComponent === 'Mensajeria' &&
                <Mensajeria onBackClick={handleBackClick}/> 

            }
            {activeComponent === 'MissingLocations' && <Location setActiveComponent={setActiveComponent} userId={user_id}/> }  
            {activeComponent === 'Performance' && <SellersAnalytics userId={user_id} setActiveComponent={setActiveComponent}/> }
            {activeComponent === 'ControlTower' && <ControlTower userId={user_id} setActiveComponent={setActiveComponent} /> }  
            {activeComponent === 'PrintDeliveries' && <AdminPrintDeliveries userId={user_id} setActiveComponent={setActiveComponent}/>}
            {activeComponent === 'AnalyticsProvider' && <AdminStatistics userId={user_id} setActiveComponent={setActiveComponent}/>}
        </div>
    );
}

export default MainAdmin;